module.exports = __webpack_public_path__ + "youtrack-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/youtrack-logo.png
// module id = 1273
// module chunks = 74